<template>
  <div>
    <x-grid :id="'childGrid'"
            :columns="columns"
            :toolbar-config="toolbarConfig"
            :editable="true"
            :edit-rules="editRules"
            :editConfig="editConfig"
            ref="grid"
            :cellClick="chooseRow"
            @edit-closed="editClosedEvent">
      >
      <template v-slot:[toolbarConfig.templatelSlots]>
        <vxe-button @click="addRow">新增</vxe-button>
        <vxe-button @click="delRow()">删除</vxe-button>
      </template>
    </x-grid>
  </div>
</template>

<script>
import XGrid from '@/components/grid/XGridChild'
import {GridChildMixin} from "@/utils/GridChildMixin";
import {
  formatter as fmt
} from "@/utils/ebase-formatter"

const fac = XGrid.factory;
console.info(fmt);//防止不使用便利 eslint报错

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumn({
    field: "prizeRank",
    title: "奖项等级",
    width: 120,
    editRender: {
      name: 'input'
    },
    editRules: [{required: true}],
  }),
  fac.makeColumn({
    field: "prizeName",
    title: "奖项名称",
    width: 160,
    editRender: {
      name: '$input',
      props: {type: 'text', maxlength: 5}
    },
    editRules: [{required: true}],
  }),
  fac.makeColumn({
    field: "winRate",
    title: "中奖概率（万分之）",
    width: 180,
    editRender: {
      name: 'input',
      props: {
        max: 10000,
        min: 0,
        type: 'integer'
      }
    },
    editRules: [{required: true}],
  }),
  fac.makeColumn({
    field: "prizeNum",
    title: "奖品数量",
    width: 120,
    editRender: {
      name: '$input',
      props: {type: 'number', min: 1}

    },
    editRules: [{required: true}],

  }),
  fac.makeColumn({
    field: "awardLeft",
    title: "剩余数量",
    width: 120
  }),
]

//可编辑表格规则 没有特殊要求的不改
const editRules = fac.makeEditRules(columns);
//工具栏按钮 没有可删除
const toolbarConfig = fac.makeToolbarConfig({
  templatelSlots: 'toolbarBtns'
});
//编辑配置
const editConfig = fac.makeEditConfig();

export default {
  mixins: [GridChildMixin],
  data() {
    return {
      editRules,
      columns,
      toolbarConfig,
      editConfig,
      oldPrizeNum: null,//未修改前数量（初始值）
    }
  },
  methods: {
    /**
     *单击表格
     */
    chooseRow({row}) {
      //获取未修改前的奖品数量
      this.oldPrizeNum = row.prizeNum
    },
    /**
     * 修改表格信息
     * @param row
     * @param column
     */
    editClosedEvent({row, column}) {
      // const $table = this.$refs['grid'].$refs['xGrid']
      const field = column.property
      const cellValue = row[field]
      // 判断单元格值是否被修改
      // if ($table.isUpdateByRow(row, field)) {
      //计算剩余数量
      if (field === "prizeNum"){
        if(row.actId && row.actId > 0){ //有id 不是新建
          row.awardLeft = Number(row.awardLeft) + (Number(cellValue) - Number(this.oldPrizeNum))
          row.awardLeft < 0 ? row.awardLeft = 0 : ''
        } else {
          row.awardLeft = Number(cellValue) || 0
        }
      }
      // }
    },
  }
}
</script>

<style scoped>
.vxe-toolbar {
  padding-left: 0
}
</style>
